var exports = {
  "Nr": "x43aef4ae--7fca0c--card",
  "p0": "x43aef4ae--7fca0c--medals",
  "C0": "x43aef4ae--7fca0c--medal",
  "TM": "x43aef4ae--7fca0c--medal-label",
  "bK": "x43aef4ae--7fca0c--gold",
  "Ut": "x43aef4ae--7fca0c--silver",
  "dy": "x43aef4ae--7fca0c--bronze",
};

module.exports = exports;
